/* ============
 * State of the auth module
 * ============
 *
 * The initial state of the auth module.
 */

export default {
  homeDevelopers: null,
  homeProjects: null,
  favProjects: null,
  favUnits: null,
  projectDetails: null,
  notifications: null,
  footerProjects: null,
  bidStrength: '',
  localities: null,
  tags: null,
  overlayState: false,
  siteDrm: {},
  city: '',
  compareData: null,
  projectList: null,
  unitDetails: null,
  projectFavUnit: null,
  listData: null,
  stats: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/home/state.js